module.exports = __webpack_public_path__ + "static/media/heart-solid.5dbbbe23.svg";